@use '@/scss/underscore' as _;

.webauthnTipContent {
  padding-inline-start: _.unit(4);
  margin: 0;
}
